import { render, staticRenderFns } from "./createTemplate.vue?vue&type=template&id=70f5ae20&scoped=true"
import script from "./createTemplate.vue?vue&type=script&lang=js"
export * from "./createTemplate.vue?vue&type=script&lang=js"
import style0 from "./createTemplate.vue?vue&type=style&index=0&id=70f5ae20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5ae20",
  null
  
)

export default component.exports